module.exports = __webpack_public_path__ + "img/MERS-Green-White.a0fd9371.png";